import { render, staticRenderFns } from "./ConsolidationUnionEditLabel.vue?vue&type=template&id=54a7d405&scoped=true"
import script from "./ConsolidationUnionEditLabel.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionEditLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7d405",
  null
  
)

export default component.exports